import { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios"

export interface GetPromocodesRequest extends Partial<AxiosRequestConfig> {
  params: {
    utm_medium?: string
  }
}

export type PromocodeListItem = {
  description: string
  value: number
  currency: string //"USD"
  promo_code_id: number //130
  promo_code: string // "Plentl22"
  is_percent: boolean //false
  promo_code_type: string // "Promotion"
  effective_from: string //"2022-09-28"
  effective_to: string //"2023-10-01"
}

interface GetListOfPromocodesResponse extends AxiosResponse {
  data: {
    body: {
      userId: number //134320
      promocodes: PromocodeListItem[]
    }
  }
}

export function getListOfPromocodesAPI(
  axiosInstance: AxiosInstance,
): Promise<GetListOfPromocodesResponse> {
  return axiosInstance({
    method: "get",
    url: `/promo/code/user/list`,
  }) as Promise<GetListOfPromocodesResponse>
}
